import { PERMISSIONS, hasPermission } from "@nimbus-erp/shared";

const routePermissions: Record<string, string> = {
  "/workspace": PERMISSIONS.dashboardView,
  "/sales": PERMISSIONS.salesRead,
  "/purchase": PERMISSIONS.purchaseRead,
  "/inventory": PERMISSIONS.inventoryRead,
  "/manufacturing": PERMISSIONS.manufacturingRead,
  "/production": PERMISSIONS.manufacturingRead,
  "/planning": PERMISSIONS.planningRead,
  "/quality": PERMISSIONS.qualityRead,
  "/equipment": PERMISSIONS.equipmentRead,
  "/settlement": PERMISSIONS.settlementRead,
  "/finance": PERMISSIONS.financeRead,
  "/workflow": PERMISSIONS.workflowRead,
  "/analytics": PERMISSIONS.analyticsRead,
  "/tasks": PERMISSIONS.taskCenterRead,
  "/master-data": PERMISSIONS.masterDataRead,
  "/master-data/references": PERMISSIONS.masterDataRead,
  "/organization/positions": PERMISSIONS.organizationRead,
  "/organization": PERMISSIONS.organizationRead,
};

export function firstBusinessRoute(permissions: string[]) {
  return (
    Object.entries(routePermissions).find(([, permission]) =>
      hasPermission(permissions, permission),
    )?.[0] ?? "/access"
  );
}

export function canNavigate(route: string, permissions: string[]) {
  if (!route.startsWith("/") || route.startsWith("//")) return false;
  const url = new URL(route, "https://erp.invalid");
  if (url.pathname === "/customer-data-review")
    return hasPermission(permissions, PERMISSIONS.organizationManage) && hasPermission(permissions, PERMISSIONS.costPriceRead);
  const permission = routePermissions[url.pathname];
  if (permission && !hasPermission(permissions, permission)) return false;
  if (
    url.pathname === "/purchase" &&
    url.searchParams.get("view") === "expenses"
  )
    return hasPermission(permissions, PERMISSIONS.costPriceRead);
  if (url.pathname === "/finance") {
    const view = url.searchParams.get("view");
    if (view === "costs")
      return hasPermission(permissions, PERMISSIONS.costPriceRead);
    if (["statements", "auxiliary", "opening", "closing", "trial", "general"].includes(view ?? ""))
      return hasPermission(permissions, PERMISSIONS.financeSensitiveRead);
  }
  if (
    url.pathname === "/workflow" &&
    ["ALL", "templates", "managers"].includes(
      url.searchParams.get("view") ?? "",
    )
  )
    return hasPermission(permissions, PERMISSIONS.workflowManage);
  return true;
}
